'use client';

import Image from 'next/image';
import { ArrowRight } from 'lucide-react';
import { Button, PAGE_CONTAINER } from './ui';
import { useTranslations } from 'next-intl';
import { TALENT_DUO_CLOSING as TALENT } from '@/lib/exam-talent';

const TRUST_KEYS = ['trust1', 'trust2', 'trust3'] as const;

export function CTA() {
  const t = useTranslations('home.cta');

  return (
    // Its own white band with equal space above and below the card. It used to
    // share the FAQ's surface with no top padding, so the card sat flush against
    // the edge of the FAQ's pattern.
    <section className="py-12 lg:py-16 bg-white">
      <div className={PAGE_CONTAINER}>
        {/* No bottom padding below lg and none at all from lg: the duo is flush with
            the card's bottom edge, and the text column carries its own vertical
            padding from lg. */}
        <div className="bg-pattern overflow-hidden rounded-3xl bg-teal-700 px-6 pt-12 sm:px-12 sm:pt-16 text-center lg:grid lg:grid-cols-[minmax(0,1fr)_auto] lg:items-center lg:gap-8 lg:p-0 lg:pl-12 lg:text-left xl:pl-16">
          <div className="lg:py-16">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-4 leading-tight">
              {t('headline')}
            </h2>

            <p className="text-lg sm:text-xl text-teal-100 mb-8 max-w-2xl mx-auto lg:mx-0">
              {t('description')}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button
                href={`${process.env.NEXT_PUBLIC_DASHBOARD_URL || 'http://localhost:3502'}/register`}
                size="lg"
                variant="primary"
                className="group w-full sm:w-auto"
              >
                {t('mulaiLatihanGratis')}
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button href="/courses" size="lg" variant="ghost-dark" className="w-full sm:w-auto">
                {t('lihatSemuaPaket')}
              </Button>
            </div>

            <div className="mt-10 flex flex-wrap justify-center lg:justify-start gap-x-8 gap-y-2 text-teal-100 text-sm">
              {TRUST_KEYS.map((key) => (
                <span key={key} className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-teal-300" />
                  {t(key)}
                </span>
              ))}
            </div>
          </div>

          <Image
            src={TALENT.src}
            width={TALENT.width}
            height={TALENT.height}
            sizes="(min-width: 1280px) 401px, (min-width: 1024px) 335px, (min-width: 640px) 299px, 248px"
            alt={t('talentAlt')}
            className="mx-auto mt-10 block h-[208px] w-auto sm:h-[250px] lg:mt-0 lg:h-80 xl:h-96 lg:self-end"
          />
        </div>
      </div>
    </section>
  );
}
